import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
declare var $: any;
import { PlannerComponent } from '../planner/planner.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faPen,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { Quill } from 'quill';
import { EditorChangeContent, EditorChangeSelection, Focus } from 'ngx-quill';
declare module 'quill';
declare var $: any;

import diff from 'fast-diff';
import QuillType from 'quill';
declare module 'quill';
import Delta from 'quill';
import { LandscaperComponent } from '../landscaper/landscaper.component';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { NotificationsComponent } from '../notifications/notifications.component';
@Component({
  selector: 'app-my-notes',
  templateUrl: './my-notes.component.html',
  styleUrls: ['./my-notes.component.scss'],
})
export class MyNotesComponent implements OnInit {
  /// icons
  faPlus = faPlus;
  faExchangeAlt = faExchangeAlt;

  modelData: any;
  entityName: any;
  aNote: any;
  matchedPersona: any;
  matchedEntity: any;
  matchedScenario: any;
  selectionAddType = false;
  addtype: any = 'Persona';
  selectedAddtype: any = {};
  noteselectAttribute: any = 'Mi';
  editorContentText: any = '';
  noteselectEUT: any = { "eName": "Choose EUT" };
  selectedString: any = '';
  testTypeFilter: any;
  selectedNoteIndex: any;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  filterTypeListS: any = { type: 'S' };
  filterTypeListI: any = { type: 'I' };
  filterTypeListN: any = { type: 'N' };
  //// controller variables open

  index: any = 0;
  eutTypes: any = ['TF', 'UR', 'BF'];
  eutTypeFilters: any = ['TF', 'UR', 'BF'];
  filterIndex: any = 0;
  designTest: any = 'E';
  searchText: any = '';
  selectedTestName: any = '';
  selectedNoteType: any = 'S';
  selectedFindNoteType: any = 'S'
  expandNotesModel: any = false;
  selectedModule: any = '';
  selectedModuleFilter: any = '';
  selectedEUT: any = '';
  selectedEUTFilter: any = 'TF';
  testTypeFilterName: any = '';
  filterEntity: any = {};
  notesEditorContent: any = '';
  newscenariolevel: any = '';
  selectedEditorLevel: any = 'L8';
  editorContent: any = '';
  filteredEntityName: any = '';
  isAdd: any = true;
  selectedEntity: any = {};
  concatNoteText: any = '';
  commonNoteText: any = '';
  showLargeTextarea: any = true;
  eutSelected: any = [];
  listOfAttributes: any;
  newscenariosymbol: any = '';
  selectedTest: any = '';
  quillEditorContent: any = '';
  selectedEntityNotes: any = {};
  editorContentText1: any = '';
  editorContent1: any = '';
  selectedString1: any = '';
  //// controller variables close

  // model
  model: any = {
    listOfEUTs: [],
    attributes: [],
    testTypes: [],
  };
  clickEventsubscriptionSocket: Subscription;

  dropUpMenuItems: any = [{ name: 'New Module', value: 'Mod' }, { name: 'New Persona', value: 'Persona' },
  { name: 'New Entity', value: 'EUT' },
  { name: 'New Scenario', value: 'SC' }];
  selectedNoteEntity: any;
  syncModelDataObject: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    public config: Config,
    private appService: AppService,
    private socketService: SocketService,
    public mainComponent: MainComponent,
    public plannerComponent: PlannerComponent,
    public interactionMapperComponent: InteractionMapperComponent,
    public LandscaperComponent: LandscaperComponent,
    public notificationsComponent: NotificationsComponent
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }

  ngOnInit(): void {
    // console.log(this.config.questionsAnswers);
    this.modelData = this._sharedService.loadedProjectData.model;

    this.selectedTestName = 'Feature Behaviour';
    var commonNoteFound = this.modelData.myNotes.find(
      (note: any) => note.noteType == 'Common'
    );
    if (commonNoteFound) {
      this.commonNoteText = commonNoteFound.noteInfo;
    } else {
      this.commonNoteText = '';
    }
    // this.entityModel=entityModel;
    this.model.listOfEUTs = this.modelData.listOfEUTs;
    this.model.myNotes = this.modelData.myNotes;
    this.model.attributes = this.modelData.listOfAttributes; /// attribute model data
    this.listOfAttributes = this.config.listOfAttributes;
    this.model.testTypes = [
      {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        eType: 'TF',
      },
      {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        eType: 'UR',
      },
      {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        eType: 'BF',
      },
    ];

    this.selectedAddtype = this.dropUpMenuItems.find(
      (att: any) => att.value == this.addtype
    );
    this.setFieldsToDefault();
    this.getMynotesData();
    // this.updateAddEUT(this.modelData.listOfEUTs[0]);
  }

  expandNotes() {
    if (this.expandNotesModel == false) {
      this.expandNotesModel = true;
      this.mainComponent.expandNotesTab(true);
    } else {
      this.expandNotesModel = false;
      this.mainComponent.expandNotesTab(false);
    }

  }
  generateAttributes(type: any) {
    // this.resetAttributes();
    $('#attributeSelect').empty();
    var Attribute: any = {};
    if (type == 'TF') {
      Attribute = {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        level: 'L4',
      };
    } else if (type == 'UR') {
      Attribute = {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        level: 'L5',
      };
    } else if (type == 'BF') {
      Attribute = {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        level: 'L5',
      };
    }
    this.config.listOfAttributesUpdated.unshift(Attribute);
    $.each(this.config.listOfAttributesUpdated, function (i: any, p: any) {
      $('#attributeSelect').append(
        $('<option title=" ' + p.name + ' " ></option>')
          .val(p.symbol)
          .html(p.symbol)
      );
    });
  }
  //// controller functions open


  updateAddEUT(eut: any) {
    this.noteselectEUT = eut;
  }

  updateAddAttr(attr: any) {
    this.noteselectAttribute = attr;
  }
  selectTest(test: any) {
    // this.newscenariolevel = test;
    this.newscenariosymbol = test.symbol;
    this.selectedTest = test;
    this.selectedTestName = test.name;
  }

  updateAddType(type: any) {
    this.selectedAddtype = this.dropUpMenuItems.find(
      (att: any) => att.value == type
    );
    this.addtype = type;
    // console.log('addType', this.addtype);
    if (
      this.addtype == 'TF' ||
      this.addtype == 'UR' ||
      this.addtype == 'BF' ||
      this.addtype == 'XX'
    ) {
      this.selectionAddType = true;
    } else {
      this.selectionAddType = false;
    }
  }

  addToEntityFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.eutSelected.push(id);
    } else {
      var isPresent = this.eutSelected.findIndex((eut: any) => eut == id);
      if (isPresent > -1) {
        this.eutSelected.splice(isPresent, 1);
      }
    }
  }

  getEntityName(eutID: any) {
    var entityFound = this.model.listOfEUTs.find(
      (eut: any) => eut.eID == eutID
    );
    if (entityFound) {
      return entityFound.eName;
    }
  }

  isPresentInCollection(eutID: any) {
    var entityFound = this.model.listOfEUTs.find(
      (eut: any) => eut.eID == eutID
    );
    if (entityFound) {
      if (this.eutSelected.length > 0) {
        var isPresent = this.eutSelected.findIndex((eut: any) => eut == eutID);
        if (isPresent > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  // quillNoteReload() {
  //   var iframe: any = document.getElementById('quillNotePad');
  //   iframe.src = iframe.src;
  // }
  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    this.editorContentText = event['editor']['root']['innerText'];
    // console.log('Changed', event);
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString = '';
      var text = event.editor.getText(range['index'], range['length']);
      // console.log("text",text);
      // console.log('text1', this.editorContentText);
      // console.log('index', this.editorContentText.replace(/\r?\n|\r/, ''));
      // var newText = this.editorContentText.replace(/\s+/g, '');
      // console.log('tt', newText.substr(range['index'], range['length']));
      this.selectedString = text.split('\n');
      // this.selectedString = cleanArray.filter(function (el: any) {
      //   return el != null;
      // });
      this.selectedString = this.selectedString.filter((item: any) => item);
      // console.log('text', this.selectedString);
    } else {
      var token = window.localStorage.getItem('publicToken');
      var projectID = window.localStorage.getItem('projectID');
      var userID = window.localStorage.getItem('userID');
      var jsonObjects = {
        projectId: projectID,
        userID: userID,
        content: this.editorContent,
      };
      this.ProjectServices.addMynotesEditorContent(jsonObjects).subscribe(
        (response: any) => {
          // console.log('res', response);
          if (response.statusCode == 200) {
            // this.quillEditorContent = response.record.content;
          } else {
          }
        }
      );
    }
  }

  checkQuillSelection() {
    // console.log('level', this.newscenariolevel);
    // console.log('EUT', this.noteselectEUT);
    // console.log('Tyepe', this.addtype);
    // console.log('this.selectedString', this.selectedString);
    // var text = quill.getText(range.index, range.length);
    // var newText = text.split("\n");
    // var addType = document.getElementById("company").value;
    var setobj: any = {
      type: this.addtype,
      data: this.selectedString,
    };
    if (
      this.addtype == 'TF' ||
      this.addtype == 'UR' ||
      this.addtype == 'BF' ||
      this.addtype == 'XX'
    ) {
      // var entity = document.getElementById("entitySelect").value;
      // var attribute = document.getElementById("attributeSelect").value;
      setobj['entity'] = this.noteselectEUT.eID;
      setobj['attribute'] = this.selectedTest;
      // setobj['level'] = this.getLevelByTestType(this.newscenariosymbol);
    }
    // console.log('setObj', setobj);
    if (setobj.type == 'Persona') {
      this.addPersonasFromEditor(setobj.data);
    } else if (
      setobj.type == 'TF' ||
      setobj.type == 'UR' ||
      setobj.type == 'BF' ||
      setobj.type == 'XX'
    ) {
      this.addScenariosFromEditor(setobj);
    }
    //  else if (
    //   setobj.type == 'STF' ||
    //   setobj.type == 'SUR' ||
    //   setobj.type == 'SBF' ||
    //   setobj.type == 'SXX'
    // ) {
    //   this.addScenariosFromEditor(setobj);
    // }
  }
  editorChangedNotes(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent1 = event['editor']['root']['innerHTML'];
    this.editorContentText1 = event['editor']['root']['innerText'];
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString1 = '';
      var text = event.editor.getText(range['index'], range['length']);

      this.selectedString1 = text.split('\n');

      this.selectedString1 = this.selectedString.filter((item: any) => item);
      // console.log('text', this.selectedString);
    } else {

    }
  }
  blur(event: Focus) {
    var foundNotes = false;
    let notesObject;
    if (this.selectedNoteEntity.eID) {
      if (this.modelData.myNotes.length > 0) {
        for (var i = 0; i < this.modelData.myNotes.length; i++) {
          if (this.modelData.myNotes[i].eID == this.selectedNoteEntity.eID) {
            this.modelData.myNotes[i]['notes'] = this.editorContent1;
            foundNotes = true;
            this.syncModelDataObject = {
              "type": "NOTES",
              "operation": "UPDATE",
              "data": this.selectedEntity,
              "notes": this.editorContent1
            }
            this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
          }
        }
        if (foundNotes == false) {
          notesObject = {
            "eID": this.selectedNoteEntity.eID,
            "notes": this.editorContent1
          }
        }
      } else {
        notesObject = {
          "eID": this.selectedNoteEntity.eID,
          "notes": this.editorContent1
        }
      }
      if (notesObject != null) {
        this.modelData.myNotes.push(notesObject);
        this.syncModelDataObject = {
          "type": "NOTES",
          "operation": "CREATE",
          "data": notesObject
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
      // console.log(this.modelData.myNotes);
    }
  }
  addPersonasFromEditor(persona: any) {
    // console.log('this.modelData', this.modelData);
    // console.log('this.modelData.persona', this.modelData.persona);
    for (var i = 0; i < persona.length; i++) {
      this.matchedPersona = this.modelData.persona.find(
        (per: any) => per.pName == persona[i]
      );
      if (!this.matchedPersona) {
        if (persona[i] != '') {
          this.add(persona[i], this.modelData.persona.length);
        }
      }
    }
  }
  addEntityFromEditor(entity: any) {
    // console.log("entity",entity);
    for (var i = 0; i < entity.data.length; i++) {
      // console.log("length",this.model.entities.length);
      // console.log("EUT",entity.data[i]);
      this.matchedEntity = this.modelData.listOfEUTs.find(
        (eut: any) => eut.eName == entity.data[i] && eut.eType == entity.type
      );
      if (!this.matchedEntity) {
        if (entity.data[i] != '') {
          this.addEUT(
            entity.data[i],
            entity.type,
            this.modelData.listOfEUTs.length
          );
        }
      }
    }
  }
  addScenariosFromEditor(scenarios: any) {
    // console.log("data",scenarios);
    for (var i = 0; i < scenarios.data.length; i++) {
      this.matchedScenario = this.modelData.scenarios.find(
        (scen: any) =>
          scen.eID == scenarios.entity &&
          scen.attribute.symbol == scenarios.attribute.symbol &&
          scen.description == scenarios.data[i]
      );
      if (!this.matchedScenario) {
        if (scenarios.data[i] != '') {
          this.addScenario(
            '',
            scenarios.data[i],
            scenarios.entity,
            scenarios.attribute,
            '-1',
            'E',
            '1',
            '+'
          );
        }
      }
    }
  }
  add(newPerson: any, id: any) {
    // console.log('newPerson', newPerson);
    var newPersonaObj = {
      pName: newPerson,
      pType: this.uniqueID('P'),
    };
    this.modelData.persona.unshift(newPersonaObj);
    // console.log(this.modelData.persona);
  }
  addEUT(newEntity: any, entityType: any, id: any) {
    var newEntityObj = {
      //eid is the unique id generated for an entity,etype being the type ->tf,bf,fl
      eID: this.uniqueID(entityType),
      eType: entityType,
      eName: newEntity,
    };
    // console.log('EUT', newEntityObj);
    this.modelData.listOfEUTs.unshift(newEntityObj);
  }
  addScenario(
    checklistName: any,
    newScenario: any,
    eID: any,
    attribute: any,
    id: any,
    sType: any,
    priority: any,
    cr: any,
  ) {
    var scenario = {
      EorT: sType,
      scenID: this.uniqueSCID(),
      description: newScenario,
      eID: eID,
      attribute: attribute,
      tID: attribute.symbol,
      priority: priority || '1',
      cr: cr || '+',
    };

    // for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
    //   if (this.modelData.listOfEUTs[i].eID == eID) {
    //     this.modelData.listOfEUTs[i].scenarioCount++;
    //   }
    // }
    var newID = id + 1;
    // console.log("scenario",scenario);
    this.modelData.scenarios.unshift(scenario);
    // this.scenarios.splice(newID, 0, scenario);
  }
  //generation of unique id for persona
  uniqueID(type: any) {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  //generation of unique id for an scenario
  uniqueSCID() {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      'SC' +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  getMynotesData() {
    var token = window.localStorage.getItem('publicToken');
    var projectID = window.localStorage.getItem('projectID');
    var userID = window.localStorage.getItem('userID');
    var jsonObjectsData = { projectId: projectID, userID: userID };
    this.ProjectServices.getMynotesEditorContent(
      jsonObjectsData,
      token
    ).subscribe((response: any) => {
      // console.log(response, 'res');
      if (response.statusCode == 200) {
        if (response.record != null) {
          this.notesEditorContent = response.record.content;
        }
      } else {
      }
    });
  }

  filterEntityName(note: any) {
    if (this.selectedEUTFilter == 'All') {
      return false;
    } else {
      if (note.eName == this.filteredEntityName) {
        return false;
      } else {
        return true;
      }
    }
  }
  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity() {
    // console.log('show');
    this.index = (this.index + 1) % this.eutTypes.length;
    this.entityName = '';
    this.aNote.testType = '';
    this.selectedTestName = '';
  }

  selectDesignType(type: any) {
    this.designTest = type;
    this.selectedEntity = {};
    this.entityName = '';
    this.aNote.testType = '';
    this.selectedTestName = '';
  }

  selectModule(test: any) {
    this.selectedEUT = test;
    this.selectedModule = test;
    this.selectedEntity = {};
    this.entityName = '';
    this.quillEditorContent = '';
    // this.selectedTest = "";
    // this.selectedTestName = "";
    // if (test == 'TT') {
    //   this.designTest = 'T';
    // } else {
    //   this.designTest = 'E';
    // }
  }

  changeFilter(test: any) {
    if (test == 'All') {
      this.filteredEntityName = '';
    }
    // for (let k = 0; k < this.eutTypeFilters.length; k++) {
    //   if (this.eutTypeFilters[k] == test) {
    //     this.filterIndex = k;
    //     this.selectedEUTFilter = test;
    //   }
    // }
    this.selectedModuleFilter = test;
    // this.filterIndex = (this.filterIndex + 1) % this.eutTypeFilters.length;
    this.filterEntity = {};
    this.testTypeFilter = '';
    this.testTypeFilterName = '';
    this.filteredEntityName = '';
    this.eutSelected = [];
  }

  selectEntityFilter(entity: any) {
    // console.log("EUT11",entity);
    this.filterEntity = entity;
    this.filteredEntityName = entity.eName;
  }

  setSelectedTestFilter(test: any) {
    this.testTypeFilter = test.symbol;
    this.testTypeFilterName = test.name;
  }

  selectEntity(entity: any) {
    this.selectedEntityNotes = this.modelData.myNotes.find(
      (eut: any) => eut.eID == entity.eID
    );
    if (this.selectedEntityNotes) {
      this.quillEditorContent = this.selectedEntityNotes.notes;
    } else {
      this.quillEditorContent = '';
    }
    // this.setFieldsToDefault();
    this.selectedNoteEntity = entity;
    // var taskFound = this.model.myNotes.find(
    //   (task: any) => task.eutID == entity.eID
    // );
    // if (!taskFound) {
    //   this.aNote.eutID = entity.eID;
    //   this.aNote.eType = entity.eType;
    //   this.aNote.eName = entity.eName;
    //   this.aNote.mID = this.selectedModule.mID;
    //   this.model.myNotes.push(this.aNote);
    // }

    this.chooseNote(entity);
  }

  chooseNote(entity: any) {
    this.selectedEntity = {};
    this.entityName = entity.eName;
    var taskFound = this.model.myNotes.find(
      (task: any) => task.eutID == entity.eID
    );
    if (taskFound) {
      this.selectedEntity = taskFound;
    }
  }

  setNoteType(type: any) {
    this.selectedNoteType = type;
  }


  setFindNoteType(type: any) {
    this.selectedFindNoteType = type;
  }
  addNoteToList(noteToBeAdded: any) {
    var note = this;
    this.model.myNotes.push(noteToBeAdded);
    this.setFieldsToDefault();
  }

  setFieldsToDefault() {
    this.designTest = 'E';
    this.entityName = '';
    this.isAdd = true;
    this.aNote = {
      noteType: 'N',
      noteScenarios: '',
      noteIssues: '',
      noteNotes: '',
      eutID: '',
      eName: '',
      eType: '',
      mID: '',
      timeStamp: Date.now(),
      actionTaken: false,
    };
    this.index = 0;
    this.selectedNoteIndex = null;
  }

  filterNoteEntity(note: any) {
    if (this.selectedEUTFilter == 'All' && this.testTypeFilterName == '') {
      return true;
    }
    var controller = this;
    if (controller.eutTypeFilters[controller.filterIndex] != 'None') {
      if (note.eutID) {
        var entity = this.model.listOfEUTs.find(
          (eut: any) => eut.eID == note.eutID
        );
        if (controller.filterEntity.eName) {
          if (entity.eID == controller.filterEntity.eID) {
            return true;
          } else {
            return false;
          }
        } else {
          return; //// added extra to avoid error
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterNoteTest(note: any) {
    if (this.selectedEUTFilter == 'All' && this.testTypeFilterName == '') {
      return true;
    }
    if (this.testTypeFilter) {
      if (note.testType == this.testTypeFilter) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  loadNote(noteSelected: any) {
    var controller = this;
    this.aNote = Object.assign({}, noteSelected);
    this.isAdd = false;
    this.selectedTestName = '';
    this.selectedNoteIndex = this.model.myNotes.indexOf(noteSelected);
    if (noteSelected.eutID) {
      var entity = this.model.listOfEUTs.find(
        (eut: any) => eut.eID == noteSelected.eutID
      );
      controller.index = this.eutTypes.indexOf(entity.eType);
      controller.entityName = entity.eName;
    }
    if (noteSelected.testType) {
      this.aNote.testType = noteSelected.testType;
      var test = this.model.attributes.find(
        (att: any) => att.symbol == noteSelected.testType
      );
      this.selectedTestName = test.name;
    }
  }

  updateNoteToList(noteToBeUpdated: any) {
    this.model.myNotes[this.selectedNoteIndex] = Object.assign(
      {},
      noteToBeUpdated
    );
    this.setFieldsToDefault();
  }

  delNoteFromList() {
    if (this.selectedNoteIndex >= 0) {
      this.model.myNotes.splice(this.selectedNoteIndex, 1);
    }
    this.setFieldsToDefault();
  }

  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  getEntityType(eType: any) {
    var entityName = this.getEntityTypeCheck(eType);
    return entityName;
  }

  generateCommonNotes() {
    var commonNoteFound = this.model.myNotes.find(
      (note: any) => note.noteType == 'Common'
    );
    if (commonNoteFound) {
      commonNoteFound.noteInfo = this.commonNoteText;
    } else {
      var commonNote = {
        noteType: 'Common',
        noteInfo: this.commonNoteText,
        eutID: 'CommonNote5964a23e0235',
        testType: 'Common',
        timeStamp: 1584340381652,
        actionTaken: false,
      };
      this.model.myNotes.push(commonNote);
    }
  }

  generateReport(auto: any) {
    let lanscapeArray = ['Notes'];
    window.localStorage.setItem('exportedData', JSON.stringify(lanscapeArray));
    if (auto == 'true') {
      window.open('/export', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  switchNoteLayout(status: any) {
    // console.log('switch status', status);

    if (status == false) {
      this.showLargeTextarea = true;
    } else {
      this.showLargeTextarea = false;
    }
  }

  //// controller functions close
  entityExistsCheck(eType: any) {
    var entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getEntityTypeCheck(eType: any) {
    if (eType == 'TF') {
      return 'Features';
    } else if (eType == 'UR') {
      return 'Requirements';
    } else {
      return 'Flows';
    }
  }

  createActivity(appname: any) {
    // console.log('appname', appname);
    var sessionID = localStorage.getItem('sessionID');
    var projectID = localStorage.getItem('projectID');
    var userID = localStorage.getItem('userID');
    if (sessionID == null) {
      sessionID = '';
    }
    let activityData = {
      appname: appname,
      sessionid: sessionID,
      projectid: projectID,
      userid: userID,
    };

    this.appService.updateActivity(activityData).subscribe((response: any) => {
      // console.log('updateActivity response', response);
      if (response.statusCode === 200) {
        if (response.sessionid != undefined) {
          localStorage.setItem('sessionID', response.sessionid);
          this.notificationsComponent.getNotifications();
        }
        if (localStorage.getItem('sessionID') != undefined && appname == 'No') {
          this.notificationsComponent.getNotifications();
        }
      }
    });
  }
}
